import { Box, Grid } from "@mui/material";

import NunitoText from "../general/NunitoText";
import ReusableButton from "../general/ReusableButton";
export default function ConfirmDeleteModal({
  deleteFunction,
  cancelDelete,
  objectName,
  id,
}) {
  return (
    <Box className="popUpModal" style={{ width: 705, minHeight: 365 }}>
      <NunitoText
        value="CONFIRM DELETE?"
        fontSize={30}
        fontWeight={600}
        color="var(--color-danger)"
        marginTop={30}
      />
      <NunitoText
        value={`Are you sure you want to delete ${objectName}?`}
        fontSize={20}
        fontWeight={600}
      />

      <Grid
        container
        justifyContent="space-evenly"
        style={{ marginBlock: "30px 20px" }}
      >
        <ReusableButton
          text="Cancel"
          bgColor="var(--color-surface)" color="var(--color-primary)" borderColor="var(--color-border-strong)"
          fontSize={25}
          height={63}
          width={280}
          onClick={() => cancelDelete()}
        />
        <ReusableButton
          text="Confirm"
          bgColor="var(--color-danger)"
          fontSize={25}
          height={63}
          width={280}
          onClick={() => deleteFunction(id)}
        />
      </Grid>
    </Box>
  );
}
